var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site"},[_c('main',{staticClass:"site-content is-flex is-flex-direction-column has-background-white"},[_c('HeaderComponent',{attrs:{"title":_vm.$t('event.booker')}}),_c('BookerComponent')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }